import { render, staticRenderFns } from "./DivChat.vue?vue&type=template&id=0941389a&"
import script from "./DivChat.vue?vue&type=script&lang=js&"
export * from "./DivChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports